import React, { useEffect, useState } from 'react';
import { ZOOPLA_PRODUCTION_URL } from 'listing-details/constants';
import {
    FacebookColourSmall,
    WhatsappColourSmall,
    TwitterColourSmall
} from '@blueprint/icons';
import {
    trackClipboardShare,
    trackFacebookShare,
    trackTwitterShare,
    trackWhatsAppShare
} from './ListingSharing.tracking';
import {
    ShareLinkButton,
    ShareButton,
    ShareList,
    ShareListItem,
    ShareListItemMobileOnly,
    ShareHeading,
    Arrow,
    LinkIcon
} from './ListingSharing.styles';
import {
    importCopyToClipboard,
    copyURLtoClipBoard,
    createFacebookLink,
    createTwitterLink,
    createWhatsappLink
} from 'shared/helpers/socialSharing.helpers';
import { ListingSharingProps } from './ListingSharing.types';

const ListingSharing = ({ data, category }: ListingSharingProps) => {
    const listingId = parseInt(data.listingId, 10);
    const title = data.title;
    const url = `${ZOOPLA_PRODUCTION_URL}${data.listingUris.detail}`;

    const [hasCopied, setHasCopied] = useState(false);

    const facebookLink = createFacebookLink(url);
    const whatsappLink = createWhatsappLink(url);
    const twitterLink = createTwitterLink(url, title);

    // Ensure dynamic library is loaded ready for when we require it as soon as
    // we are rendered for the first time
    useEffect(() => {
        importCopyToClipboard();
    }, []);

    return (
        <>
            <ShareHeading size="5">
                Share this property with your friends and family
            </ShareHeading>
            <ShareList>
                <ShareListItem>
                    <ShareLinkButton
                        onClick={() => trackFacebookShare(listingId, category)}
                        target="_blank"
                        href={facebookLink}
                        data-testid="listing-sharing-facebook"
                    >
                        <FacebookColourSmall /> <span>Facebook</span> <Arrow />
                    </ShareLinkButton>
                </ShareListItem>
                <ShareListItem>
                    <ShareLinkButton
                        onClick={() => trackTwitterShare(listingId, category)}
                        target="_blank"
                        href={twitterLink}
                        data-testid="listing-sharing-twitter"
                    >
                        <TwitterColourSmall /> <span>Twitter</span> <Arrow />
                    </ShareLinkButton>
                </ShareListItem>
                <ShareListItemMobileOnly>
                    <ShareLinkButton
                        onClick={() => trackWhatsAppShare(listingId, category)}
                        href={whatsappLink}
                        data-action="share/whatsapp/share"
                        data-testid="listing-sharing-whatsapp"
                    >
                        <WhatsappColourSmall /> <span>WhatsApp</span> <Arrow />
                    </ShareLinkButton>
                </ShareListItemMobileOnly>
                <ShareListItem>
                    <ShareButton
                        onClick={() => {
                            trackClipboardShare(listingId, category);
                            copyURLtoClipBoard(url)
                                .then(() => setHasCopied(true))
                                .catch(() => setHasCopied(false));
                        }}
                        data-testid="listing-sharing-copylink"
                    >
                        <LinkIcon />{' '}
                        <span>{hasCopied ? 'Link copied!' : 'Copy link'}</span>{' '}
                    </ShareButton>
                </ShareListItem>
            </ShareList>
        </>
    );
};

export default ListingSharing;
